import { withI18n } from 'react-i18next';
import SamsungOrderSearchForm from './SamsungOrderInvoiceSearchForm';
import SamsungOrderResultTable from './SamsungOrderInvoiceResultTable';
import MenuForSamsungPage from './MenuForSamsungInvoiceView';

export const SamsungOrderInvoiceSearchForm = withI18n()(SamsungOrderSearchForm);
export const SamsungOrderInvoiceResultTable = withI18n()(
  SamsungOrderResultTable
);
export const MenuForSamsungInvoiceView = withI18n()(MenuForSamsungPage);
